import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../../utils/index.js";
import { AcquisitionForm } from "../../AcquisitionForm/index.js";
import { ModuleLayout } from "../Layout/ModuleLayout.js";
import { deriveChildEmphasis } from "../Module.types.js";
const ModuleSubscribe_ModuleSubscribe = /*#__PURE__*/ forwardRef(function({ formType, formProps, children, ...sectionProps }, ref) {
    const formEmphasis = deriveChildEmphasis(sectionProps.emphasis);
    const resolvedFormProps = {
        ...formProps,
        emphasis: formEmphasis,
        ...formType && {
            type: formType
        }
    };
    return /*#__PURE__*/ jsx(ModuleLayout, {
        ref: ref,
        ...sectionProps,
        contentSlotClassName: cn('simpleSplit' === sectionProps.display && '@2xl:items-center', sectionProps.contentSlotClassName),
        children: children ?? /*#__PURE__*/ jsx("div", {
            className: "w-full",
            children: /*#__PURE__*/ jsx(AcquisitionForm, {
                ...resolvedFormProps
            })
        })
    });
});
export { ModuleSubscribe_ModuleSubscribe as ModuleSubscribe };
